/*@ngInject*/
const DropdownPopoverController = function ($scope, $element) {

    this.$onInit = function () {
        $element.addClass('umDropdownPopoverComponent');
    };
};

angular.module('umCore')
    .controller('umDropdownPopoverController', DropdownPopoverController);
